export default "__VITE_ASSET__CZpeHm8U__"